import utils from "Sources/utils/utils";
import request from "Sources/services/request";

let MediaAssetService = {};

((MediaAssetService) =>
{
  MediaAssetService.getAvatars = function()
  {
    return request.get({
      url:  utils.getServiceUrl("/media_assets/avatars"),
      cache: false,
      dataType: request.DATA_TYPES.JSON,
      contentType: request.CONTENT_TYPES.APPLICATION_JSON
    })
      .then(MediaAssetService.onServiceComplete);
  };

  MediaAssetService.getThumbs = function()
  {
    return request.get({
      url:  utils.getServiceUrl("/media_assets/thumbs"),
      cache: false,
      dataType: request.DATA_TYPES.JSON,
      contentType: request.CONTENT_TYPES.APPLICATION_JSON
    })
      .then(MediaAssetService.onServiceComplete);
  };

  MediaAssetService.onServiceComplete = function (data)
  {
    if(utils.isNotNull(data) && data.result === "success" && data.data)
    {
      return data.data;
    }

    return null;
  }

})(MediaAssetService);

module.exports = MediaAssetService;



// WEBPACK FOOTER //
// ./app/js/services/media-asset-service.js